import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import "./index.css"
import { initPostHog } from "./lib/posthog"
import { initSentry } from "./lib/sentry"

// Initialize Sentry and PostHog before rendering app
initSentry()
initPostHog()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)
